import ExtendableObject from "./ExtendableObject";
import {arrayRemove, assign, hasOwn, isString} from "./voidash";

export var Event = ExtendableObject.extend({
  constructor(type, target, payload) {
    this.type = type;
    this.target = target;
    assign(this, payload);
    this.propagationStopped = false;
  }
});
//=============================================================================
export var DestroyEvent = Event.extend({
  constructor(target) {
    Event.call(this, "destroy", target);
    this.propagationStopped = true;
  }
});
//=============================================================================
export var EventEmitter = ExtendableObject.extend({
  constructor(asynchronous) {
    this.listeners = {};
    this.listening = [];
    if (typeof asynchronous === 'undefined') this.asynchronous= false;
    else this.asynchronous=asynchronous;
    this.inAsynchronousCall=false;
  },

  on(type, cb, prioritize) {
    if(!hasOwn(this.listeners, type)) this.listeners[type] = [];
    if(prioritize) this.listeners[type].unshift(cb);
    else this.listeners[type].push(cb);
  },

  /**
   * Report the first occurrence of the event after binding.
   * @param type
   * @param cb
   * @return {function} The actual callback function bound. Calling it calls cb and removes the handler.
   */
  once(type, cb) {
    const final_cb = (...args) => {
      cb(...args);
      this.off(type, final_cb);
    };

    this.on(type, final_cb);

    return final_cb;
  },

  off(type, cb) {
    if(!hasOwn(this.listeners, type)) return;
    arrayRemove(this.listeners[type], cb);
    if (this.listeners[type].length === 0) delete this.listeners[type];
  },

  emit(evtOrType, payloadIfType = null) {
    const evt = isString(evtOrType) ? new Event(evtOrType, this, payloadIfType) : evtOrType;
    this._emit(evt.type, evt);
    this._emit("all", evt);
  },

  _emit(type, evt) {
    if (!this.listeners.hasOwnProperty(type)) return;
    const callbacks = this.listeners[type];
    if (!this.asynchronous) {
      for (const cb of callbacks) cb.call(this, evt);
    } else if (callbacks.length) {
      callbacks[0].call(this, evt); // spinner
      setTimeout(function () {
        this.inAsynchronousCall = true;
        for (let i = 1; i < callbacks.length; i++) callbacks[i].call(this, evt);
        this.inAsynchronousCall = false;
      }, 1);
    }
  },

  listenTo(emitter, type, cb, prioritize) {
    emitter.on(type, cb, prioritize);
    const record = { emitter: emitter, type: type, cb: cb };
    this.listening.push(record);
    emitter.on("destroy", () => { arrayRemove(this.listening, record); });
    return record;
  },

  stopListeningTo(record) {
    record.emitter.off(record.type, record.cb);
    arrayRemove(this.listening, record);
  },

  stopListening() {
    this.listening.forEach(function(record) { record.emitter.off(record.type, record.cb); });
    this.listening = [];
  },

  proxy(emitter, type) {
    return this.listenTo(emitter, "all", evt => {
      if(!evt.propagationStopped && (!type || evt.type === type)) {
        this.emit(evt);
      }
    });
  },

  destroy() {
    this.stopListening();
    this.emit(new DestroyEvent(this));
  }
});